import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const ElevatorIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M108.501 64.0001L121.672 50.8285C123.235 49.2665 125.767 49.2665 127.33 50.8285L140.501 64.0001" stroke={color} strokeWidth="6" strokeLinecap="round" />
            <path d="M108.501 104L121.672 117.171C123.235 118.734 125.767 118.734 127.33 117.171L140.501 104" stroke={color} strokeWidth="6" strokeLinecap="round" />
            <path
                d="M52.5 65C60.7842 65 67.5 58.2842 67.5 50C67.5 41.7158 60.7842 35 52.5 35C44.2158 35 37.5 41.7158 37.5 50C37.5 58.2842 44.2158 65 52.5 65Z"
                stroke={color}
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M52.535 129.828C32.5 129.828 32.5 79.8282 32.5 79.8282H72.5C72.5 79.8282 72.5 129.828 52.465 129.828H52.535Z"
                stroke={color}
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
